import { produce } from 'immer';
import { ALL_POKER_VARIANT_PROPERTIES, ALL_POKER_VARIANTS } from '../../types/pokerVariantTypes';
import { getHtmlTextContent } from '../../utils/htmlUtils';
import { BECOME_MTT_OWNER, CLEAR_MTT_STAGING_SCENE, ENTER_MTT_STAGING_PLAYER_FROM_INBOUND, HIDE_MTT_STAGING_PRIZE_WIN, INIT_MTT_STAGING_FROM_INBOUND, LEAVE_MTT_STAGING_PLAYER_FROM_INBOUND, RENAME_MTT_STAGING_ROOM, SET_MTT_STAGING_PLAYER_BANK, SET_MTT_STAGING_TABLES_FROM_INBOUND, SET_MY_PLAYER_ID, SHOW_MTT_STAGING_PRIZE_WIN_FROM_INBOUND, UPDATE_MTT_STAGING_INFO_FROM_INBOUND, UPDATE_MTT_STAGING_PLAYER_READY_STATE_FROM_INBOUND, UPDATE_MTT_STAGING_PLAYERS_FROM_INBOUND, UPDATE_MTT_STAGING_TABLE_FROM_INBOUND } from '../actions/mttStagingActions';
const initialState = {
    players: [],
    mttStagingTables: []
};
/**
 * TODO: This is a hack that could probably be removed later, either because it's no longer needed, or the API is updated to include this information cleanly.
 */
function getPokerVariantFromMttSettingsHtml(mttSettingsHtml) {
    const text = getHtmlTextContent(mttSettingsHtml);
    if (text) {
        for (let i = 0; i < ALL_POKER_VARIANTS.length; i++) {
            const currentPokerVariant = ALL_POKER_VARIANTS[i];
            if (text.includes(ALL_POKER_VARIANT_PROPERTIES[currentPokerVariant].name)) {
                return currentPokerVariant;
            }
        }
    }
}
/**
 * TODO: This is a hack that could probably be removed later, either because it's no longer needed, or the API is updated to include this information cleanly.
 */
function getIsMixedGameFromMttSettingsHtml(mttSettingsHtml) {
    const text = getHtmlTextContent(mttSettingsHtml);
    if (text) {
        return text.includes('Mixed Game');
    }
    return false;
}
const mttStagingReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_MTT_STAGING_SCENE: {
                return initialState;
            }
            case INIT_MTT_STAGING_FROM_INBOUND: {
                const { gameName, players, isMttReady, bonusMttStartingChipsPercentForPowerPlayer, isOwner, mttSettingsHtml, mttStagingTables, autoMttTimerSecondsRemaining, infoMarkdown } = action.payload;
                draft.gameName = gameName;
                draft.players = players;
                draft.isMttReady = isMttReady;
                draft.bonusMttStartingChipsPercentForPowerPlayer = bonusMttStartingChipsPercentForPowerPlayer;
                draft.isTourneyOwner = isOwner;
                draft.mttSettingsHtml = mttSettingsHtml;
                draft.mttStagingTables = mttStagingTables;
                draft.autoMttTimerEndTimestampMs =
                    autoMttTimerSecondsRemaining !== -1 ? performance.now() + autoMttTimerSecondsRemaining * 1000 : undefined;
                draft.pokerVariant = getPokerVariantFromMttSettingsHtml(mttSettingsHtml);
                draft.isMixedGame = getIsMixedGameFromMttSettingsHtml(mttSettingsHtml);
                draft.infoMarkdown = infoMarkdown;
                break;
            }
            case ENTER_MTT_STAGING_PLAYER_FROM_INBOUND: {
                const { player } = action.payload;
                const existingPlayerIndex = draft.players.findIndex((currentPlayer) => currentPlayer.id === player.id);
                if (existingPlayerIndex !== -1) {
                    // this is likely an existing player that is reconnecting to the room, replace it
                    draft.players.splice(existingPlayerIndex, 1, player);
                }
                else {
                    draft.players.push(player);
                }
                break;
            }
            case LEAVE_MTT_STAGING_PLAYER_FROM_INBOUND: {
                const playerId = action.payload.playerId;
                draft.players = draft.players.filter((player) => player.id !== playerId);
                break;
            }
            case UPDATE_MTT_STAGING_PLAYER_READY_STATE_FROM_INBOUND: {
                const { playerId, isMttReady } = action.payload;
                const existingPlayer = draft.players.find((currentPlayer) => currentPlayer.id === playerId);
                if (existingPlayer) {
                    existingPlayer.isMttReady = isMttReady;
                }
                if (draft.myPlayerId === playerId) {
                    // updating my ready state
                    draft.isMttReady = isMttReady;
                }
                break;
            }
            case BECOME_MTT_OWNER: {
                draft.isTourneyOwner = true;
                break;
            }
            case UPDATE_MTT_STAGING_INFO_FROM_INBOUND: {
                draft.mttSettingsHtml = action.payload.html;
                break;
            }
            case SET_MTT_STAGING_TABLES_FROM_INBOUND: {
                draft.mttStagingTables = action.payload.mttStagingTables;
                break;
            }
            case UPDATE_MTT_STAGING_TABLE_FROM_INBOUND: {
                draft.mttStagingTables = draft.mttStagingTables.map((existingMttStagingTable) => existingMttStagingTable.roomId === action.payload.mttStagingTable.roomId
                    ? action.payload.mttStagingTable
                    : existingMttStagingTable);
                break;
            }
            case SET_MY_PLAYER_ID: {
                draft.myPlayerId = action.payload;
                break;
            }
            case SET_MTT_STAGING_PLAYER_BANK: {
                const existingPlayer = draft.players.find((player) => player.id === action.payload.playerId);
                if (existingPlayer) {
                    const { numChipsInBank, mttStartingChips } = action.payload;
                    existingPlayer.numChipsInBank = numChipsInBank;
                    existingPlayer.mttStartingChips = mttStartingChips;
                }
                break;
            }
            case UPDATE_MTT_STAGING_PLAYERS_FROM_INBOUND: {
                draft.players = action.payload.players;
                break;
            }
            case RENAME_MTT_STAGING_ROOM: {
                draft.gameName = action.payload;
                break;
            }
            case SHOW_MTT_STAGING_PRIZE_WIN_FROM_INBOUND: {
                const { winnerId, messageToOthers, messageToWinner, prizeDescription, durationMs } = action.payload;
                draft.prizeWin = { winnerId, messageToOthers, messageToWinner, prizeDescription, durationMs };
                break;
            }
            case HIDE_MTT_STAGING_PRIZE_WIN: {
                delete draft.prizeWin;
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default mttStagingReducer;
